/*
 * YAMIWARD — 闇区診断 (WARD DIAGNOSIS)
 * Seven questions, eleven possible files. Matches the visitor to a Codex
 * entity, then hands off to codex.js (window.YW_CODEX) for the full dossier
 * and product link. Share card is drawn on canvas from text/kanji only —
 * no remote images, so the canvas never taints.
 */
(function () {
    'use strict';

    var STORE_URL = 'yamiward.com';
    var RESULT_KEY = 'yw_quiz_result';

    // Option weights: { codexEntryNumber: points }
    var QUESTIONS = [
        {
            q: 'It is 2 a.m. You are still awake because —',
            options: [
                { t: 'Someone has to keep watch. It might as well be someone good at it.', w: { 1: 3, 9: 1 } },
                { t: 'The night is when I actually exist.', w: { 2: 2, 3: 2 } },
                { t: 'The screen is warm and the feed remembers my name.', w: { 7: 3, 8: 1 } },
                { t: 'I am organizing tomorrow. Again. It will be flawless. Again.', w: { 11: 3, 10: 1 } }
            ]
        },
        {
            q: 'Your role in the group chat:',
            options: [
                { t: 'Silent for weeks, then I show up exactly when it matters.', w: { 1: 2, 9: 2 } },
                { t: 'They forget I am in it until I reply something devastating.', w: { 3: 3, 2: 1 } },
                { t: 'I made the group chat. I run the group chat.', w: { 6: 2, 11: 2 } },
                { t: 'I am the story they tell people who just joined.', w: { 8: 2, 5: 2 } }
            ]
        },
        {
            q: 'Pick a workspace:',
            options: [
                { t: 'A forge. Loud, hot, honest.', w: { 4: 3, 5: 1 } },
                { t: 'A little shop with a bell on the door. Visitors welcome. Mostly.', w: { 6: 3, 11: 1 } },
                { t: 'A hangar, lights off, one machine humming.', w: { 9: 3, 8: 1 } },
                { t: 'Wherever I am standing. I am the workspace.', w: { 10: 2, 2: 2 } }
            ]
        },
        {
            q: 'Your relationship with rules:',
            options: [
                { t: 'I am the rule.', w: { 1: 2, 10: 2 } },
                { t: 'I keep the schedule. The schedule does not keep me.', w: { 11: 3, 6: 1 } },
                { t: 'The rules list me as missing. The rules are half right.', w: { 8: 2, 3: 2 } },
                { t: 'I read the manual once. Then I improved it.', w: { 4: 2, 9: 2 } }
            ]
        },
        {
            q: 'Someone wrongs you. You —',
            options: [
                { t: 'Say nothing. Everyone passes under my gaze eventually.', w: { 10: 3, 1: 1 } },
                { t: 'Nothing visible happens. Their tools go missing, one at a time.', w: { 3: 3, 9: 1 } },
                { t: 'Full volume. Third eye open. Right now.', w: { 4: 2, 5: 2 } },
                { t: 'Let the static handle it. They will get a call.', w: { 7: 3, 2: 1 } }
            ]
        },
        {
            q: 'Take one souvenir from the Ward:',
            options: [
                { t: 'A coal that stays warm for exactly one day.', w: { 5: 3, 4: 1 } },
                { t: 'A ticket stub, torn at the Gate.', w: { 10: 2, 11: 2 } },
                { t: 'One bar of signal in a dead zone.', w: { 7: 2, 2: 2 } },
                { t: 'A receipt marked ALL SALES FINAL, signed kindly.', w: { 6: 3, 1: 1 } }
            ]
        },
        {
            q: 'The last train tonight is the Kage Line. No listed destination. Do you board?',
            options: [
                { t: 'I have been on it the whole time.', w: { 2: 3, 3: 1 } },
                { t: 'I board. Someone on it might need me.', w: { 1: 2, 6: 1 } },
                { t: 'I do not ride trains. I fly over them.', w: { 8: 3 } },
                { t: 'I confirm it departs on time, then wave it off.', w: { 11: 2, 10: 1 } }
            ]
        }
    ];

    var stage = null;
    var current = 0;
    var scores = {};

    function el(tag, cls, text) {
        var node = document.createElement(tag);
        if (cls) node.className = cls;
        if (text !== undefined) node.textContent = text;
        return node;
    }

    function pad(n) { return (n < 10 ? '00' : '0') + n; }

    function codexEntry(n) {
        if (!window.YW_CODEX) return null;
        var list = window.YW_CODEX.entries;
        for (var i = 0; i < list.length; i++) if (list[i].n === n) return list[i];
        return null;
    }

    /* ---------- Screens ---------- */

    function showIntro() {
        stage.innerHTML = '';
        var box = el('div', 'quiz-box');
        box.appendChild(el('div', 'quiz-kicker', 'RECORDS OFFICE — INTAKE FORM 闇-11'));
        box.appendChild(el('h3', 'quiz-heading', 'Which spirit are you?'));
        box.appendChild(el('p', 'quiz-sub', 'Seven questions. Eleven files. The Records Office will match you to the entity your paperwork already resembles. Results are final, in the way Ward paperwork is always final.'));

        var saved = null;
        try { saved = JSON.parse(localStorage.getItem(RESULT_KEY) || 'null'); } catch (e) { /* ignore */ }
        if (saved && saved.n) {
            var entry = codexEntry(saved.n);
            if (entry) box.appendChild(el('p', 'quiz-prev', 'Your file on record: ENTRY ' + pad(entry.n) + ' — ' + entry.name + '. Retakes are permitted. The Office enjoys them.'));
        }

        var btn = el('button', 'btn btn-primary quiz-start-btn', saved ? 'RETAKE THE DIAGNOSIS' : 'BEGIN THE DIAGNOSIS');
        btn.addEventListener('click', startQuiz);
        box.appendChild(btn);
        stage.appendChild(box);
    }

    function startQuiz() {
        current = 0;
        scores = {};
        showQuestion();
    }

    function showQuestion() {
        var Q = QUESTIONS[current];
        stage.innerHTML = '';
        var box = el('div', 'quiz-box');

        var prog = el('div', 'quiz-progress');
        for (var i = 0; i < QUESTIONS.length; i++) {
            var dot = el('span', 'quiz-dot' + (i < current ? ' done' : i === current ? ' now' : ''));
            prog.appendChild(dot);
        }
        prog.appendChild(el('span', 'quiz-progress-label', 'Q' + (current + 1) + ' / ' + QUESTIONS.length));
        box.appendChild(prog);

        box.appendChild(el('h3', 'quiz-question', Q.q));

        Q.options.forEach(function (opt) {
            var b = el('button', 'quiz-option');
            b.type = 'button';
            b.textContent = opt.t;
            b.addEventListener('click', function () {
                for (var k in opt.w) scores[k] = (scores[k] || 0) + opt.w[k];
                current++;
                if (current < QUESTIONS.length) showQuestion();
                else showResult();
            });
            box.appendChild(b);
        });

        stage.appendChild(box);
    }

    function winner() {
        var best = null, bestScore = -1;
        // Stable order tie-break: earlier codex entries win ties.
        var keys = Object.keys(scores).map(Number).sort(function (a, b) { return a - b; });
        keys.forEach(function (k) {
            if (scores[k] > bestScore) { bestScore = scores[k]; best = k; }
        });
        return best || 1;
    }

    function showResult() {
        var n = winner();
        var entry = codexEntry(n);
        if (!entry) { showIntro(); return; }
        var f = window.YW_CODEX.factions[entry.faction];

        try { localStorage.setItem(RESULT_KEY, JSON.stringify({ n: n, at: Date.now() })); } catch (e) { /* ignore */ }

        stage.innerHTML = '';
        var box = el('div', 'quiz-box quiz-result');
        box.style.setProperty('--quiz-accent', f.color);

        box.appendChild(el('div', 'quiz-kicker', 'DIAGNOSIS COMPLETE — FILE MATCHED'));

        var head = el('div', 'quiz-result-head');
        head.appendChild(el('span', 'quiz-result-no', 'CODEX ENTRY ' + pad(entry.n)));
        if (window.YW_CODEX.sightedNow(entry)) {
            head.appendChild(el('span', 'codex-sighted', 'SIGHTED TONIGHT'));
        }
        box.appendChild(head);

        var nameRow = el('h3', 'quiz-result-name', entry.name + ' ');
        nameRow.appendChild(el('span', 'quiz-result-kanji', entry.kanji));
        box.appendChild(nameRow);
        box.appendChild(el('div', 'quiz-result-meta', entry.cls + ' · ' + f.label + (entry.threat && entry.threat !== 'N/A' && entry.threat !== '—' ? ' · THREAT CLASS ' + entry.threat : '')));
        box.appendChild(el('p', 'quiz-result-fragment', entry.fragment));
        var note = el('p', 'quiz-result-note');
        note.appendChild(el('span', 'quiz-note-label', 'FIELD NOTE — '));
        note.appendChild(document.createTextNode(entry.note));
        box.appendChild(note);

        var actions = el('div', 'quiz-actions');

        var markBtn = el('button', 'btn btn-primary', 'VIEW YOUR MARK →');
        markBtn.addEventListener('click', function () { window.YW_CODEX.scrollToProduct(entry.match); });
        actions.appendChild(markBtn);

        var fileBtn = el('button', 'btn btn-secondary', 'OPEN FULL DOSSIER');
        fileBtn.addEventListener('click', function () { window.YW_CODEX.open(entry.n); });
        actions.appendChild(fileBtn);

        var cardBtn = el('button', 'btn btn-secondary', 'DOWNLOAD RESULT CARD');
        cardBtn.addEventListener('click', function () { downloadCard(entry, f); });
        actions.appendChild(cardBtn);

        var shareBtn = el('button', 'btn btn-secondary', 'SHARE');
        shareBtn.addEventListener('click', function () { share(entry, shareBtn); });
        actions.appendChild(shareBtn);

        box.appendChild(actions);

        var retake = el('button', 'quiz-retake', 'The Office misfiled me — retake');
        retake.addEventListener('click', startQuiz);
        box.appendChild(retake);

        var resident = el('a', 'quiz-resident-link', 'Take your file to the Records Office — claim your Resident ID →');
        resident.href = '#resident';
        box.appendChild(resident);

        stage.appendChild(box);
        box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /* ---------- Share ---------- */

    function shareText(entry) {
        return 'The Yamiward Records Office matched me to ENTRY ' + pad(entry.n) + ' — ' + entry.name + ' (' + entry.kanji + '). Which spirit are you?';
    }

    function share(entry, btn) {
        var url = 'https://' + STORE_URL + '/#quiz';
        var text = shareText(entry);
        if (navigator.share) {
            navigator.share({ title: 'Yamiward — 闇区診断', text: text, url: url }).catch(function () { /* user cancelled */ });
        } else if (navigator.clipboard) {
            navigator.clipboard.writeText(text + ' ' + url).then(function () {
                var old = btn.textContent;
                btn.textContent = 'COPIED!';
                setTimeout(function () { btn.textContent = old; }, 1600);
            });
        }
    }

    /* ---------- Canvas result card (1080×1350, text/kanji only) ---------- */

    function roundRect(ctx, x, y, w, h, r) {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.arcTo(x + w, y, x + w, y + h, r);
        ctx.arcTo(x + w, y + h, x, y + h, r);
        ctx.arcTo(x, y + h, x, y, r);
        ctx.arcTo(x, y, x + w, y, r);
        ctx.closePath();
    }

    function wrapText(ctx, text, x, y, maxWidth, lineHeight, maxLines) {
        var words = text.split(' ');
        var line = '', lines = 0;
        for (var i = 0; i < words.length; i++) {
            var test = line ? line + ' ' + words[i] : words[i];
            if (ctx.measureText(test).width > maxWidth && line) {
                ctx.fillText(line, x, y);
                y += lineHeight;
                lines++;
                line = words[i];
                if (maxLines && lines >= maxLines - 1) {
                    var rest = line + (i < words.length - 1 ? ' ' + words.slice(i + 1).join(' ') : '');
                    while (ctx.measureText(rest + '…').width > maxWidth && rest.length) rest = rest.slice(0, -1);
                    ctx.fillText(rest + '…', x, y);
                    return y + lineHeight;
                }
            } else {
                line = test;
            }
        }
        if (line) { ctx.fillText(line, x, y); y += lineHeight; }
        return y;
    }

    function downloadCard(entry, f) {
        var draw = function () {
            var W = 1080, H = 1350;
            var canvas = document.createElement('canvas');
            canvas.width = W; canvas.height = H;
            var ctx = canvas.getContext('2d');

            // Background
            ctx.fillStyle = '#05050A';
            ctx.fillRect(0, 0, W, H);
            var grad = ctx.createRadialGradient(W * 0.8, H * 0.1, 50, W * 0.8, H * 0.1, 900);
            grad.addColorStop(0, 'rgba(229,30,37,0.12)');
            grad.addColorStop(1, 'rgba(0,0,0,0)');
            ctx.fillStyle = grad;
            ctx.fillRect(0, 0, W, H);

            // Giant watermark kanji
            ctx.save();
            ctx.globalAlpha = 0.08;
            ctx.fillStyle = f.color;
            ctx.font = '900 560px "Noto Sans JP", sans-serif';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(entry.kanji.slice(0, 1), W / 2, H / 2 + 40);
            ctx.restore();

            // Frame
            ctx.strokeStyle = f.color;
            ctx.lineWidth = 6;
            roundRect(ctx, 40, 40, W - 80, H - 80, 8);
            ctx.stroke();
            ctx.strokeStyle = 'rgba(255,255,255,0.12)';
            ctx.lineWidth = 1;
            roundRect(ctx, 56, 56, W - 112, H - 112, 6);
            ctx.stroke();

            // Header
            ctx.textAlign = 'center';
            ctx.fillStyle = 'rgba(243,243,245,0.65)';
            ctx.font = '700 30px "Space Mono", monospace';
            ctx.fillText('YAMIWARD — RECORDS OFFICE', W / 2, 140);
            ctx.fillStyle = '#E51E25';
            ctx.font = '900 44px "Noto Sans JP", sans-serif';
            ctx.fillText('闇 区 診 断', W / 2, 200);

            // Entry number + threat
            ctx.fillStyle = f.color;
            ctx.font = '700 34px "Space Mono", monospace';
            ctx.fillText('CODEX ENTRY ' + pad(entry.n), W / 2, 320);

            // Name
            ctx.fillStyle = '#F3F3F5';
            ctx.font = '900 76px Outfit, sans-serif';
            var name = entry.name;
            while (ctx.measureText(name).width > W - 200 && name.length > 4) {
                ctx.font = '900 ' + Math.max(48, parseInt(ctx.font, 10) - 6) + 'px Outfit, sans-serif';
                if (parseInt(ctx.font, 10) <= 48) break;
            }
            ctx.fillText(name, W / 2, 430);

            // Kanji subtitle
            ctx.fillStyle = f.color;
            ctx.font = '900 54px "Noto Sans JP", sans-serif';
            ctx.fillText(entry.kanji, W / 2, 510);

            // Class / faction / threat
            ctx.fillStyle = 'rgba(243,243,245,0.7)';
            ctx.font = '400 30px "Space Mono", monospace';
            ctx.fillText(entry.cls, W / 2, 590);
            ctx.fillText(f.label + (entry.threat && entry.threat !== 'N/A' && entry.threat !== '—' ? '  ·  THREAT CLASS ' + entry.threat : ''), W / 2, 640);

            // Divider
            ctx.strokeStyle = 'rgba(255,255,255,0.15)';
            ctx.beginPath();
            ctx.moveTo(200, 700);
            ctx.lineTo(W - 200, 700);
            ctx.stroke();

            // Field note (the punchline)
            ctx.fillStyle = 'rgba(243,243,245,0.85)';
            ctx.font = 'italic 400 34px Outfit, sans-serif';
            wrapText(ctx, '“' + entry.note + '”', W / 2, 780, W - 260, 50, 5);

            // Footer CTA
            ctx.fillStyle = '#F3F3F5';
            ctx.font = '700 40px Outfit, sans-serif';
            ctx.fillText('WHICH SPIRIT ARE YOU?', W / 2, H - 180);
            ctx.fillStyle = f.color;
            ctx.font = '700 30px "Space Mono", monospace';
            ctx.fillText(STORE_URL, W / 2, H - 120);

            var a = document.createElement('a');
            a.download = 'yamiward-entry-' + pad(entry.n) + '-' + entry.name.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '.png';
            a.href = canvas.toDataURL('image/png');
            a.click();
        };

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(draw);
        } else {
            draw();
        }
    }

    /* ---------- Init ---------- */

    function init() {
        stage = document.getElementById('quiz-stage');
        if (!stage || !window.YW_CODEX) return;
        showIntro();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
